<script>
	import Bubble from '$lib/Components/Layout/Bubble/Bubble.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	let { backgroundColor = 'white' } = $props();
</script>

<Section {backgroundColor}>
	<h2>Grade Types</h2>
	<p>
		Each grade blocks drafts and reduces outside noises, but our premium grades
		have special features to make your existing windows work the way they're
		designed to while providing additional benefits. <a
			href="/custom-storm-windows"
			>Click here to read all of our grade descriptions</a
		>.
	</p>

	<Bubble class="!max-w-full" backgroundColor="transparent">
		<div class="flex justify-center">
			<ul
				class="list-big center grid w-auto grid-rows-2 gap-x-12 gap-y-8 text-xl md:grid-cols-3"
			>
				<li class="capitalize">
					<a href="/custom-storm-windows/standard-grade">Standard Grade</a>
				</li>
				<li class="capitalize">
					<a href="/custom-storm-windows/commercial-grade">Commercial Grade</a>
				</li>
				<li class="capitalize">
					<a href="/custom-storm-windows/acoustic-grade">Acoustic Grade</a>
				</li>
				<li class="capitalize">
					<a href="/custom-storm-windows/museum-grade">Museum Grade</a>
				</li>
				<li class="capitalize">
					<a href="/custom-storm-windows/sleep-panel">Sleep Grade</a>
				</li>
				<li class="capitalize">
					<a href="/custom-storm-windows/privacy-grade">Privacy Grade</a>
				</li>
			</ul>
		</div>
	</Bubble>
	<p>
		To take the next steps on your order, there are two ways to submit your
		window measurements: an Indow provided laser, or your own tape measure.
		Either way, your measurements will be checked and confirmed by our
		proprietary measurement software Measure by Indow. This ensures a snug fit
		for your custom window insert.
	</p>
	<p>
		To get a free estimate, <a href="/how-to/get-indow-inserts"
			>contact us today.</a
		>
	</p>
</Section>
